angular.module("app")
	.directive("okinaMapControlAddressSearch", [
		"FitiSubscriptionService", "$timeout", "OkinaLeafletService",
		function (FitiSubscriptionService, $timeout, OkinaLeafletService) {
		"use strict";

		return {
			restrict: "E",
			templateUrl: "common/directives/geoloc/okinaMapControls/address-search/okinaMapControlAddressSearch.html",
			link: function ($scope) {
				$scope.displaySearch = false;
				$scope.data = {
					searchValue: "",
					listSearchedAddress: []
				};

				let debouncedSearch;
				$scope.refreshAddressList = (address) => {
					$timeout.cancel(debouncedSearch);

					debouncedSearch = $timeout( () => {FitiSubscriptionService.getAddress(address)
						.then((response) => {
							const data = response.data;
							let addressList = [];
							data.features.forEach((feature) => {
								addressList.push({
									label: feature.properties.label,
									city: feature.properties.city,
									zipCode: feature.properties.postcode,
									coordinates: feature.geometry.coordinates
								});
							});

							$scope.data.listSearchedAddress = addressList;
						})}, 1000);
				};

				$scope.$watch("data.searchValue", (newValue) => {
					if (angular.isObject(newValue)
						&& angular.isDefined(newValue.coordinates)) {

						let searchMarker = {
							lat: parseFloat(newValue.coordinates[1]),
							lng: parseFloat(newValue.coordinates[0]),
							message: $scope.data.searchValue.label,
							draggable: false,
							icon: {
								type: "awesomeMarker",
								icon: "flag",
								prefix: "fa",
								markerColor: "red"
							}
						};
						zoomToCoords(newValue.coordinates[1],
							newValue.coordinates[0],
							searchMarker);
					}
				});



				/**
				 * Zoom aux coordonnées indiquées
				 * @param lat
				 * @param lng
				 * @param searchMarker
				 */
				function zoomToCoords(lat, lng, searchMarker) {
					OkinaLeafletService.deleteMarkerWithName("searchMarker");
					OkinaLeafletService.createMarkerWithName("searchMarker", searchMarker);

					OkinaLeafletService.setCenter({
						lat: searchMarker.lat,
						lng: searchMarker.lng,
						zoom: 18
					});
				}
			}
		};
	}]
	);
